export const applyHero = {
  title: '申込フォーム',
  titleEn: 'APPLICATION',
  lead: '以下のフォームより、受講のお申込みを承ります。必要事項をご入力のうえ、内容確認へお進みください。',
};

export const applyPreCheckItems = [
  {
    icon: 'ri-user-line',
    label: '18歳以上（高校生不可）',
    description: '年齢の下限を除き、国籍・性別・経験は一切問いません。',
  },
  {
    icon: 'ri-group-line',
    label: '先着順（定員6名）',
    description: '各開校日の定員は6名です。定員に達し次第、締め切ります。',
  },
  {
    icon: 'ri-bank-line',
    label: '銀行振込・一括払いのみ',
    description: '分割払い・クレジットカードには対応しておりません。',
  },
  {
    icon: 'ri-calendar-check-line',
    label: '申込締切は開校14日前',
    description: '最少催行人数は3名。未達時は全額返金または次期振替（5%優待）を承ります。',
  },
];

export const applyFormOptions = {
  courses: [
    { value: 'essential', label: 'エッセンシャルコース' },
    { value: 'advanced', label: 'アドバンスコース' },
    { value: 'master', label: 'マスターコース' },
  ],
  terms: [
    { value: '2026-autumn', label: '2026年 秋期（9月開校）' },
    { value: '2027-spring', label: '2027年 春期（4月開校）' },
    { value: '2027-autumn', label: '2027年 秋期（9月開校）' },
    { value: 'undecided', label: '未定（相談して決めたい）' },
  ],
  transferOptions: [
    { value: 'none', label: 'なし' },
    { value: 'essential-completed', label: 'E修了（エッセンシャル修了）' },
    { value: 'advanced-completed', label: 'A修了（アドバンス修了）' },
  ],
};

export const applyFaqs = [
  {
    question: '申込後の流れは?',
    answer: '送信後2営業日以内にご連絡し、受講契約とお支払い（銀行振込）のご案内をお送りします。お振込み確認後に受講確定です。',
  },
  {
    question: '申込を取り消せますか?',
    answer: '所定の期間内であればキャンセルを承ります。条件は受講契約時にご案内します。',
  },
  {
    question: '電話でも申し込めますか?',
    answer: 'お電話（平日10:00〜17:00）でもご相談を承りますが、正式なお申込みはフォームのご提出をお願いしています。',
  },
];

export const applyRelatedPages = [
  {
    title: '応募資格・申込の流れ',
    description: '資格と申込手順',
    href: '/application',
  },
  {
    title: '個別相談予約',
    description: '無料・オンライン可の相談',
    href: '/consultation',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: '年間スケジュール',
    description: '開校時期と授業日程',
    href: '/schedule',
  },
];